<template>
  <base-page>
    <div class="content-view">
      <van-pull-refresh v-model="state.refreshLoading" @refresh="onRefresh">
        <van-list v-if="dataList && dataList.length > 0" :loading="state && state.loading" :finished="state && state.finished" @load="getMessage" :immediate-check="false">
          <div class="list-view">
            <div class="new-content">
              <div class="con1" v-for="item in dataList" :key="item.id" @click="path(item)">
                <img v-if="item.readStatus === '2'" src="../../assets/images/person/new.png" />
                <div class="div2" :style="{ color: item.readStatus === '2' ? '#333333' : '#666666' }" v-html="item.content"></div>
                <div class="div3">{{ item && item.createTime }}</div>
              </div>
            </div>
          </div>
        </van-list>
        <EmptyView class="empty-view" v-else title="暂无数据" :description="''" />
      </van-pull-refresh>
    </div>
    <div v-if="isShow" class="ffd">
      <div class="sope"></div>
      <div class="bck">
        <div class="title">系统消息</div>
        <div class="content-text" v-html="msg" @click="jumpMessage"></div>
      </div>
      <img src="../../assets/images/person/close.png" class="img" @click="closes" />
    </div>
  </base-page>
</template>

<script>
import BasePage from '../../components/BasePage.vue'
import EmptyView from '../../components/EmptyView.vue'
import { getSystemMessage, MessageStateUp } from '../../api/systemMessage'
import { Toast } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'systemMessages',
  components: {
    BasePage,
    EmptyView
  },
  data() {
    return {
      state: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        refreshLoading: false
      },
      jumpData: {
        targetType: 0,
        projectId: '',
        taskId: '',
        trainId: '',
        trainTaskId: '',
        userHomeworkId: '',
        studentUserId: '',
        id: '',
        roleTypes: 0,
        reviewable: 0,
        staffTaskId: '',
        isJumping: 0,
        applyStatus: ''
      },
      jumpDataFin: {
        trainTaskId: '',
        trainId: '',
        courseEType: 3,
        studyState: '',
        studentUserId: '',
        projectId: ' '
        // 定义一个projectId
      },
      isShow: false,
      msg: '',
      dataList: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    getMessage() {
      Toast.loading('')
      let params = {
        iepUserId: this.userInfo.userId,
        pageNum: this.state.pageNo.toString(),
        pageSize: this.state.pageSize.toString()
      }
      getSystemMessage(params)
        .then(res => {
          Toast.clear()
          if (!res.data || !res.data.list) {
            this.dataList = []
            this.state.finished = true
            return false
          }
          if (res && res.data) {
            // this.dataList = JSON.parse(JSON.stringify(res.data))
            let dataIdList = this.dataList.map(item => {
              return item.id || ''
            })
            if (res.data.list && res.data.list.length) {
              res.data.list.forEach(item => {
                if (!dataIdList.includes(item.id)) {
                  // 将时间戳转成成时间
                  if (item.createTime) {
                    item.createTime = this.$moment(parseInt(item.createTime)).format('YYYY-MM-DD HH:mm:ss')
                  }
                  if (item.content) {
                    item.content = `<font color="#fe6a23">${this.userInfo.realName}</font>${item.content}`
                  }
                  this.dataList.push(item)
                }
              })
              this.state.pageNo++
              this.state.finished = this.dataList.length >= res.data.total
            }
          }
        })
        .catch(err => {
          Toast(err.msg || '请求失败')
        })
        .finally(() => {
          this.state.refreshLoading = false
          this.state.loading = false
        })
    },
    onRefresh() {
      this.dataList = []
      this.state.pageNo = 1
      this.state.pageSize = 10
      this.getMessage()
    },
    path(data) {
      this.jumpData.targetType = data.targetType ? data.targetType : 1
      this.jumpData.projectId = data.projectId ? data.projectId : ''
      this.jumpData.taskId = data.taskId ? data.taskId : ''
      this.jumpData.trainId = data.trainId ? data.trainId : ''
      this.jumpData.trainTaskId = data.trainTaskId ? data.trainTaskId : ''
      this.jumpData.userHomeworkId = data.userHomeworkId ? data.userHomeworkId : ''
      this.jumpData.studentUserId = data.studentUserId ? data.studentUserId : ''
      this.jumpData.id = data.userTeacherTaskId ? data.userTeacherTaskId : ''
      this.jumpData.reviewable = data.reviewable ? data.reviewable : 0
      this.jumpData.roleTypes = data.roleTypes ? data.roleTypes : 0
      this.jumpData.isJumping = data.isJumping ? data.isJumping : 0
      this.jumpData.staffTaskId = data.userExclusiveTaskId ? data.userExclusiveTaskId : ''
      this.jumpData.applyStatus = data.applyStatus ? data.applyStatus + '' : ''
      this.jumpDataFin.trainId = data.trainId ? data.trainId : ''
      this.jumpDataFin.projectId = data.projectId ? data.projectId : ''
      this.jumpDataFin.trainTaskId = data.trainTaskId ? data.trainTaskId : ''
      this.jumpDataFin.courseEType = data.courseEType ? data.courseEType : 3
      this.jumpDataFin.studyState = data.studyState ? data.studyState : ''
      this.jumpDataFin.studentUserId = data.studentUserId ? data.studentUserId : ''
      this.isShow = true
      this.msg = data.content
      if (data.readStatus === '1') return false
      MessageStateUp({
        iepUserId: this.userInfo.id,
        messageId: data.id
      }).then(() => {
        this.dataList = []
        this.state.pageNo = 1
        this.state.pageSize = 10
        this.getMessage()
      })
    },
    closes() {
      this.isShow = false
    },
    jumpMessage() {
      if (this.jumpData.targetType === 1) {
        this.$router.push('/home')
      }
      if (this.jumpData.isJumping === 1) {
        if (this.jumpData.targetType === 1) {
          this.$router.go(-1)
        }
        // 课程详情页
        if (this.jumpData.targetType === 2) {
          this.$router.push({
            path: '/course/category-course',
            query: { ...this.jumpDataFin }
          })
        }
        // 练习提交页面-已经不用了
        if (this.jumpData.targetType === 3) {
          this.$router.push({
            path: '/exercise/detail',
            query: { ...this.jumpData }
          })
        }
        // 练习审批页面-已经不用了
        if (this.jumpData.targetType === 4) {
          this.$router.push({
            path: '/exercise/grading',
            query: { ...this.jumpData }
          })
        }
        // 作业提交页面
        if (this.jumpData.targetType === 5) {
          this.$router.push({
            path: '/teacher-task/stu-detail',
            query: { ...this.jumpData }
            // query: { id: this.jumpData.id } // 旧版--没有统一全局消息
          })
        }
        // 作业审批页面
        if (this.jumpData.targetType === 6) {
          this.$router.push({
            path: '/teacher-task/grading',
            query: { ...this.jumpData }
            // query: { id: jumpData.id } // 旧版--没有统一全局消息
          })
        }
        // 旧的关键行为详情页-已经不用了
        if (this.jumpData.targetType === 7) {
          this.$router.push({
            path: '/staff-task',
            query: { ...this.jumpData }
            // query: { staffTaskId: jumpData.staffTaskId } // 旧版--没有统一全局消息
          })
        }
        // 旧的练习包列表页-已经不用了
        if (this.jumpData.targetType === 13) {
          this.$router.push({
            path: '/home/detail',
            query: { ...this.jumpData }
            // 全局 消息统一 加了这个jumpData传过去，主要是projectId
          })
        }
        // 进修中心审核页
        if (this.jumpData.targetType === 16) {
          this.$router.push({
            path: '/application-study/application-review',
            query: { tabActiveUrl: this.jumpData.applyStatus, ...this.jumpData }
          })
        }
        // 新的关键任务审批页
        if (this.jumpData.targetType === 17) {
          this.$router.push({
            path: '/task-package/grading',
            query: { ...this.jumpData, isShowAgent: 2, taskNameShowType: 1 }
          })
        }
        // 新的关键任务提交页
        if (this.jumpData.targetType === 18) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 1, taskNameShowType: 2 }
          })
        }
        if (this.jumpData.targetType === 19) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 1, taskNameShowType: 2 }
          })
        }
        if (this.jumpData.targetType === 20) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 1, taskNameShowType: 2 }
          })
        }
        if (this.jumpData.targetType === 21) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 1, taskNameShowType: 2 }
          })
        }
        if (this.jumpData.targetType === 22) {
          this.$router.push({
            path: '/task-package/grading',
            query: { ...this.jumpData, isShowAgent: 2, taskNameShowType: 1 }
          })
        }
        if (this.jumpData.targetType === 23) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 2, taskNameShowType: 1 }
          })
        }
        if (this.jumpData.targetType === 24) {
          this.$router.push({
            path: '/task-package/detail',
            query: { ...this.jumpData, isShowAgent: 2, taskNameShowType: 1 }
          })
        }
      }
    }
  },
  mounted() {
    this.getMessage()
    console.log('time', this.$moment(parseInt('1675175003000')).format('YYYY-MM-DD HH:mm:ss'))
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.content-view {
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  padding: 12px 12px;
  font-size: 13px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  overflow-x: hidden;
  box-sizing: border-box;
  .list-view {
    width: 100%;
    min-height: calc(100vh - 24px);
    /*overflow: hidden;*/
    .new-content {
      padding: 3px 0 0 3px;
      .con1 {
        background: #ffffff;
        box-shadow: 4px 7px 20px 0px rgba(0, 0, 0, 0.04);
        border-radius: 5px;
        height: 65px;
        margin-bottom: 15px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          right: 19px;
          top: 27px;
          color: #999999;
          border-top: 2px solid;
          border-left: 2px solid;
          transform: rotate(131deg);
        }
        img {
          width: 26px;
          height: 26px;
          position: absolute;
          left: -2px;
          top: -2px;
        }
      }
      .div2 {
        width: 86%;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        padding: 10px 0 9px 16px;
        position: relative;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .div3 {
        font-size: 11px;
        font-weight: 500;
        color: #666666;
        padding: 0 0 10px 16px;
      }
    }
  }
  .empty-view {
    width: 100%;
    height: 100vh;
  }
}
.ffd {
  position: fixed;
  top: 0px;
  .sope {
    width: 375px;
    height: 750px;
    position: fixed;
    z-index: 9;
    background: #000000;
    opacity: 0.48;
    padding-top: 110px;
  }
  .bck {
    margin: 0 30px;
    height: 300px;
    top: 150px;
    background: #ffffff;
    border-radius: 5px;
    padding: 16px;
    position: relative;
    z-index: 10;
    .title {
      opacity: 1;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      color: #1f333f;
      text-align: center;
    }
    .content-text {
      margin-top: 16px;
      font-size: 13px;
      font-weight: 500;
      line-height: 24px;
      color: #1f333f;
      span {
        color: blue !important;
        border-bottom: 1px solid blue !important;
      }
    }
  }
  .img {
    width: 24px;
    margin: 168px 175px;
    position: relative;
    z-index: 10;
  }
}
/deep/ .content-text {
  span {
    color: blue !important;
    border-bottom: 1px solid blue !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/systemMessages/systemMessages.vue